var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(-7476 -2623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_786",
    "data-name": "Ellipse 786",
    transform: "translate(7476 2623)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M18.663,7.591c.013.185.013.37.013.554a12.046,12.046,0,0,1-12.13,12.13A12.047,12.047,0,0,1,0,18.361a8.819,8.819,0,0,0,1.029.053,8.538,8.538,0,0,0,5.293-1.821,4.271,4.271,0,0,1-3.986-2.957,5.376,5.376,0,0,0,.805.066,4.509,4.509,0,0,0,1.122-.145A4.264,4.264,0,0,1,.845,9.373V9.32a4.293,4.293,0,0,0,1.927.541,4.269,4.269,0,0,1-1.32-5.7,12.118,12.118,0,0,0,8.79,4.461,4.813,4.813,0,0,1-.106-.977,4.267,4.267,0,0,1,7.378-2.917A8.393,8.393,0,0,0,20.22,3.7a4.252,4.252,0,0,1-1.874,2.349,8.546,8.546,0,0,0,2.455-.66,9.164,9.164,0,0,1-2.138,2.2Z",
    transform: "translate(7488.199 2634.172)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.d6594c736d6544147a3c26f7ae87e59f.svg";
export { ForwardRef as ReactComponent };